'use client'

import { SplitsLink } from '~/components/Link'
import { Toggleable } from '~/components/component-library'
import { useSmartAccounts } from '~/hooks/useSmartAccounts'
import { useWorkspaceAutoEarn } from '~/hooks/useWorkspaceAutoEarn'
import { SmartAccountRole } from '~/types'
import {
  getChainLabel,
  properlyFormatOneOrMoreChainNames,
} from '~/utils/chainLabels'

export const WorkspaceAutoEarnToggle = () => {
  const { data, toggle, isPending } = useWorkspaceAutoEarn()
  const { smartAccounts } = useSmartAccounts()

  const treasury = smartAccounts.find(
    (account) => account.role === SmartAccountRole.TREASURY,
  )

  const enabledChainIds = data?.enabledChainIds ?? []
  const eligibleChainIds = data?.eligibleChainIds ?? []
  const pendingTransactionId = data?.pendingTransactionId
  const isOn = enabledChainIds.length > 0
  const hasNoEligibleNetwork = !!data && !isOn && eligibleChainIds.length === 0

  return (
    <div className="flex flex-col gap-2">
      <Toggleable
        label="Auto-earn for workspace"
        description={
          isOn
            ? `USDC on ${properlyFormatOneOrMoreChainNames(
                enabledChainIds.map((chainId) => getChainLabel(chainId)),
              )}`
            : hasNoEligibleNetwork
              ? 'No network qualifies for auto-earn'
              : 'Deposit workspace USDC into Earn'
        }
        isChecked={isOn}
        onCheckedChange={toggle}
        isDisabled={
          !data || isPending || !!pendingTransactionId || hasNoEligibleNetwork
        }
      />
      {pendingTransactionId && treasury && (
        <SplitsLink
          path={`/accounts/${treasury.address}/transactions/${pendingTransactionId}/`}
          underline
          className="text-sm"
        >
          Transaction pending approval
        </SplitsLink>
      )}
    </div>
  )
}
